// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"698192d8","348":"24291e75"}[chunkId] + ".css";
};